import api from '@pray/shared/utils/api';

import type { SuperFunnelContractStatus, SuperFunnelProductType } from './getAccounts';

export type SuperFunnelContract = {
  id: string;
  artist_id: string;
  artist_name: string | null;
  product_type: SuperFunnelProductType | null;
  types?: SuperFunnelProductType[];
  status: SuperFunnelContractStatus | null;
  exception_flag: boolean;
  contract_date: string | null;
  service_start_date: string | null;
  cancel_date: string | null;
  target_spend_pct: string | null;
  contract_term_months: number | null;
  // Pre-fee gross TCV — what the client agreed to pay across the term.
  // Distinct from total_budget_cents (ad spend budget). Display as the
  // headline "Contract value" on the detail page.
  contract_value_cents: number | null;
  total_budget_cents: number | null;
  cpm_cents: number | null;
  service_fee_percent: string | null;
  created_at: string | null;
};

export type GetSuperFunnelContractsParams = {
  accountId: string;
  productType?: SuperFunnelProductType;
  contractStatus?: SuperFunnelContractStatus;
};

export type GetSuperFunnelContractsResponse = {
  contracts: SuperFunnelContract[];
};

export const getContracts = async ({
  accountId,
  productType,
  contractStatus,
}: GetSuperFunnelContractsParams): Promise<GetSuperFunnelContractsResponse> => {
  const params: Record<string, string> = {};

  if (productType !== undefined) params.product_type = productType;
  if (contractStatus !== undefined) params.contract_status = contractStatus;

  const url = `/web/studio/superfunnel/accounts/${accountId}/contracts`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as { data: GetSuperFunnelContractsResponse }).data;
};
